import { constructionSafety, logisticsAsset, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '여러분은 휴대폰이 자동차와 원활하게 연결되거나, 스마트 기기가 여러분의 위치를 센티미터 단위로 정확하게 파악하는 방법을 궁금해한 적이 있나요? 그 답은 UWB(Ultra-Wideband)라는 첨단 기술에 있습니다. 이 글에서는 UWB가 무엇인지, 그 놀라운 응용 분야, 그리고 어떻게 작동하는지 알아보겠습니다. 시작해 볼까요!',
  keywords: 'UWB, 초광대역, UWB 실내 위치 추적, UWB 스마트 홈',
  ogSite: 'UWB란 무엇인가요? 용도와 작동 원리',
  title: 'UWB란 무엇인가요? 용도와 작동 원리',
  ogUrl: 'https://orbro.io/blog/what-is-uwb?',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_G98WlYMkFRS7Of1CzH3prv3AmpIJ8MWyIv4zkyrTNi4dCPNv8YReguvP5Qx-TYC5ACSlmDrSZ33NySPOW9_6wgO_q7B2LQTb0_Cbf_n1rODruLdsY8-aQVLgTVq7aMN3IFjvwp3RaNnJnBs-ygzyr-34sUGOqkXbLmQFuIjHWCaXNfbYXunFtOGBVD_Wwhv3JmnHTe6vOi9soYjdZbwY_7KSA95eQifQfWcswZA2MHcKxhvbcA6_ekxPYDkbZh4t8WN8O6nwtwVDVkmPE6wB8HHSDxryFrK5E2MDrTXc7ZDUwASbufd4bz40kA9bkiePNOFA2SjyLzTIHEfV7Hsys6kmSmEIk9wPhRriRoqCGU3WWXBRvMNmhajCS_0i8tgyeiiFF7rL16xi1cs0LADl8MPQOXMGlScxq7SLROl_sWzuwcLcEPiJd8rchMmEaG6ri1auSUnZ2Xr8x0FcqrOXYJZ53I1chFvp0-5bxlnCXobv9tHDDxdYqvfYQ6L2XDOngvghHuPg867BoRp3M1HWLFUhRtyhBuNmlU3A6sg4HsbV2-r-B8QLAej8UOVIa4588QQFXiGD5_PJXhclaJ7lTz_-BI0_c-JAvtKzPhloC301I16A0fWQe5yXzU-jlK09yLQwKxBV66ZEnyorc2JJy25RyeBxl0QRpsmYhHb2KSSY_9HCb7bPJPgyS_8nSwV6gcVKzT9N0CXVyIB-Ww9X1Y0DukLOm_m3ToG5g0W8RkX3DezT8hNKOsjaT69Hp1x-J4Ni-EPE69lTvapIi9XJ_4ROBFJBVL7N-D6D34q11D-OCsfJXg70DqZzaHVcMW0KFrD9IX5XzTlekPAFW5Hu5XL_XGc730bj05gaMf3TL9A77sbbULOwpq9GzExAYpswWbQmn8X0q-axGx7Zn65HpmJJGhZ3AFe_LZtPQNQlyqpZf1ihKpNI4A1ER1JYmOuKR7WwY6w807uLkKOOkJYBxm1gvv7yamt-U3gpC9_yEYRG2n4IXYd8hfSKf4UpV_OSO4eiXhRktI2st5R9sYmBBFcYuyXUlWNemQMLc7h_efEv_0CMoE_ZRqCqKupFjfnFAVk6bchz26Eic4Z7MRXH8qjkWBhgQDZa92cjhELKtD3fcR_q-kMIWCD3weLYIgqNhbzU5BesHpEOfPLWHKHTEFd6T2F2YjiQYKVeyOEwBpHk_aNU01ZWufRIk4i69tzo1P4KszH83SuN2dO76wvA2m-4KQCvbWsxC-nJ_bwCPN0Bl6CBa8xPOj7PdZmpb9_m_2J4-Cu8iJyqzMQhDo0zAmwcbyybRePoee1wyb9Maf3wTe2Xx8kUFeZuMakCx43LEFhheX-Rm7y73C_dFdvE4qiques4Sqmt7mhXrzJVWalwK3UD-sfM09hwX-NUpSFBkbC9iPPDirAAc8irYdr6w2A2dM0iPH6beRWi2qlfzXXMeRkHZXYC9UCCbWTQskids1ulaRL4dJFATbt0NFWxSTtCMewJ61EeZvFchBcExAYBClpjTQEK7LEehhcYixzFwa3V-FjWojUXWhasOa9QrE4pnIvNQHmh4lAzhYGOu5aVF-DWK4f6E7NbGdp7R_ddih5v95gAaYBo9GKh8uGwDSyyDdP3AcLKKZEZNrgA=w1418-h1440?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-08',
  tag1: '#UWB',
  tag2: '#초광대역',
  tag3: '#UWB실내위치추적',
  tag4: '#UWB스마트홈',
  text: [
    {
      head: '',
      subHead: '',
      desc: '여러분은 휴대폰이 자동차와 원활하게 연결되거나, 스마트 기기가 여러분의 위치를 센티미터 단위로 정확하게 파악하는 방법을 궁금해한 적이 있나요? 그 답은 UWB(Ultra-Wideband)라는 첨단 기술에 있습니다. 이 글에서는 UWB가 무엇인지, 그 놀라운 응용 분야, 그리고 어떻게 작동하는지 알아보겠습니다. 시작해 볼까요!',
      dot: ''
    },
    {
      head: 'UWB란 무엇인가요?',
      subHead: '',
      desc: 'UWB(Ultra-Wideband), 즉 초광대역은 넓은 주파수 대역을 사용해 짧은 거리에서 높은 정밀도로 데이터를 전송하는 무선 통신 기술입니다. Wi-Fi나 Bluetooth와 달리, UWB는 복잡한 환경에서도 뛰어난 정밀도의 위치 추적과 효율적인 작동을 자랑합니다. 이 기술은 스마트폰, 자동차, 스마트 홈 시스템 등 다양한 현대 기기에 적용되어 빠르고 안전한 연결 경험을 제공합니다.\n\n예시: 자동차 근처에 서면 UWB를 사용하는 스마트 키가 버튼을 누르지 않아도 자동으로 문을 열어줍니다. 이는 정확한 거리 측정 덕분입니다.',
      dot: ''
    },
    {
      head: 'UWB의 작동 원리',
      subHead: '',
      desc: 'UWB는 어떻게 작동할까요? 다음은 이 기술의 작동 방식입니다:\n\n짧은 라디오 펄스: UWB는 연속적인 신호 대신 매우 짧은 라디오 펄스를 넓은 주파수 대역(보통 500MHz 이상)으로 발사합니다.\n\n비행 시간 측정(Time of Flight): 두 기기 사이에서 펄스가 이동하는 시간을 계산해 정확한 거리를 측정합니다.\n\n정밀한 위치 추적: 여러 기준점을 결합해 물체의 3D 위치를 수 센티미터의 오차로 파악합니다.\n\n간섭 저항: 넓은 주파수 대역을 사용해 간섭에 강하며, 벽이나 금속과 같은 장애물을 통과할 수 있습니다.\n\n예시: 집 안에서 UWB는 여러 전자 기기가 동시에 작동해도 당신이 어느 방에 있는지 정확하게 파악할 수 있습니다.',
      dot: ''
    },
    {
      head: 'UWB의 용도',
      subHead: '',
      desc: 'UWB는 위치 추적뿐만 아니라 일상생활에서 다양한 실용적인 용도로 사용됩니다. 다음은 몇 가지 주요 용도입니다:\n\n실내 위치 추적\n응용: 창고나 쇼핑몰과 같은 밀폐된 공간에서 사람이나 물체의 위치를 추적합니다.\n예시: 슈퍼마켓에서 UWB를 사용하는 지도 앱으로 원하는 매장을 쉽게 찾을 수 있습니다.\n\n스마트 기기 연결\n응용: 휴대폰, 헤드폰, 스마트 스피커 간의 빠른 연결을 지원합니다.\n예시: 방에 들어가면 UWB 덕분에 휴대폰이 자동으로 스피커에 연결되어 음악을 재생합니다.\n\n비접촉 키\n응용: 사용자의 위치를 기반으로 자동차나 집 문을 엽니다.\n예시: Tesla 자동차는 UWB를 사용해 사용자가 다가오면 자동으로 문을 엽니다.\n\n자산 추적\n응용: 창고 내 상품 관리나 분실물 찾기에 활용됩니다.\n예시: Apple AirTag는 UWB를 사용해 잃어버린 열쇠를 높은 정밀도로 찾을 수 있게 도와줍니다.\n\n의료 분야 응용\n응용: 의료 장비 추적이나 환자 모니터링에 사용됩니다.\n예시: 병원에서는 UWB를 사용해 심박 측정기의 정확한 위치를 파악합니다.',
      dot: ''
    },
    {
      head: 'UWB가 특별한 이유',
      subHead: '',
      desc: 'Bluetooth나 Wi-Fi와 비교해 UWB는 다음과 같은 뛰어난 장점을 가지고 있습니다:\n\n더 높은 정밀도: 위치 추적 오차가 10-30cm에 불과한 반면, GPS는 보통 5-10m입니다.\n\n간섭이 적음: 혼잡한 환경에서도 잘 작동합니다.\n\n에너지 효율성: 스마트워치와 같은 소형 기기에 적합합니다.\n\n높은 보안성: 짧은 펄스와 복잡한 암호화로 해킹이 어렵습니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: 'UWB는 무선 기술의 큰 도약으로, 다른 기술들이 따라오기 힘든 정밀도, 편리함, 보안을 제공합니다. 자동차 문 열기, 분실물 찾기, 스마트 홈 연결 등 UWB는 우리가 주변 세계와 상호작용하는 방식을 변화시키고 있습니다. UWB의 잠재력을 탐구할 준비가 되셨나요?',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
